import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, take } from 'rxjs';

@Component({
  selector: 'app-delete',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDividerModule,
  ],
  templateUrl: './delete.component.html',
  styleUrl: './delete.component.css',
})
export class DeleteComponent {
  // Variables
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  handler: () => Observable<any>;
  snackBar: any;

  // Variable para prevenir múltiples ejecuciones
  isDeleting = false;

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<DeleteComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmText: string;
      cancelText: string;
      handler: () => Observable<any>;
    }
  ) {
    // Obtener los datos del dialogo
    this.title = data.title;
    this.message = data.message;
    this.confirmText = data.confirmText;
    this.cancelText = data.cancelText;
    this.handler = data.handler;
  }

  // Metodo para abrir el snackbar
  private _snackBar = inject(MatSnackBar);
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 7000,
    });
  }

  // Función para eliminar
  deleteSelected() {
    // Prevenir múltiples ejecuciones
    if (this.isDeleting) {
      //  console.log('Eliminación ya en progreso, ignorando click adicional');
      return;
    }

    this.isDeleting = true;
    //console.log('Iniciando eliminación...');

    this.handler()
      .pipe(take(1))
      .subscribe({
        next: () => {
          // console.log('Eliminación exitosa');
          this.dialogRef.close(true);
          this.openSnackBar('Eliminado correctamente', 'Cerrar');
          this.isDeleting = false;
        },
        error: (error) => {
          //  console.log('Delete error details:', {
          //    status: error?.status,
          //     statusText: error?.statusText,
          //    message: error?.message,
          //    error: error
          //  });

          // Detect CORS error (status 0, Unknown Error) or 404 OK and treat as success
          if (
            (error &&
              error.status === 0 &&
              error.statusText === 'Unknown Error') ||
            (error && error.status === 404 && error.statusText === 'OK')
          ) {
            console.warn(
              'CORS or 404 error detected, treating as successful deletion'
            );
            this.dialogRef.close(true);
            this.openSnackBar('Eliminado correctamente', 'Cerrar');
          } else {
            console.error('Error en eliminación:', error);
            this.dialogRef.close(false);
            this.openSnackBar('Error al eliminar', 'Cerrar');
          }
          this.isDeleting = false;
        },
      });
  }

  onCancel() {
    if (this.isDeleting) {
      //    console.log('No se puede cancelar mientras se está eliminando');
      return;
    }
    this.dialogRef.close(false);
  }
}
